import { Lozenge } from 'shared/lozenge/Lozenge';
import { tokens } from 'styles/tokens';

export type KCFOnlyLozengeProps = {
    id?: string;
};

export function KCFOnlyLozenge({ id }: KCFOnlyLozengeProps) {
    return (
        <Lozenge
            id={id}
            color={tokens.text.onColor}
            backgroundColor={tokens.surface.dark}
        >
            KCF
        </Lozenge>
    );
}
